'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLocalLibrary = function MdLocalLibrary(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 13.4c-2.7 0-5-2.3-5-5s2.3-5 5-5 5 2.2 5 5-2.3 5-5 5z m0 5.8c3.9-3.7 9.2-5.8 15-5.8v18.2c-5.8 0-11.1 2.3-15 6-3.9-3.7-9.2-6-15-6v-18.2c5.8 0 11.1 2.1 15 5.8z' })
        )
    );
};

exports.default = MdLocalLibrary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/local-library.js
// module id = 1693
// module chunks = 168707334958949